webpackJsonp([70144966829960],{

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(70);
	
	var _helloColor = __webpack_require__(63);
	
	var _helloColor2 = _interopRequireDefault(_helloColor);
	
	var _colors2 = __webpack_require__(11);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	var _colors4 = __webpack_require__(56);
	
	var _colors = _interopRequireWildcard(_colors4);
	
	var _mapProps = __webpack_require__(7);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _styleguide = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactContainer = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.FlexChild).withConfig({
	  displayName: 'contact__ContactContainer'
	})(['max-width:32rem;']);
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _styleguide.ContentRow,
	    null,
	    _react2.default.createElement(
	      _styleguide.Flex,
	      { align: 'center', justify: 'center' },
	      _react2.default.createElement(
	        ContactContainer,
	        null,
	        _react2.default.createElement(
	          _styleguide.Title,
	          { h: '2', scale: '3', my: '0', width: 'auto' },
	          'Contact us'
	        ),
	        _react2.default.createElement(
	          _styleguide.Paragraph,
	          { mb: '3', scale: '2', width: 'auto' },
	          'Enim sint aliqua mollit consequat laboris qui ex. Sit sint aute aliqua velit qui esse nostrud laboris quis. Mollit amet veniam exercitation commodo anim laborum pariatur id velit. Cupidatat non fugiat ea cupidatat esse amet id ad excepteur. Ut exercitation aute ut nostrud ex in duis ut aliqua ullamco. Pariatur ut adipisicing Lorem pariatur ad voluptate incididunt fugiat officia amet proident consectetur.'
	        )
	      )
	    ),
	    _react2.default.createElement(_styleguide.ViewportRibbon, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-e1bed63ec03c93b9127c.js